export default {"src":"/_next/static/media/bs.fb213cab.svg","height":22,"width":30,"blurWidth":0,"blurHeight":0};